// Storage keys
export const STORAGE_KEYS = {
  USER_SETTINGS: 'userSettings',
  POMODORO_STATE: 'pomodoroState',
  USER: 'user',
  API_TOKEN: 'api_token'
};

/**
 * User settings storage operations
 */
export const userSettingsStorage = {
  get: () => {
    try {
      const settings = localStorage.getItem(STORAGE_KEYS.USER_SETTINGS);
      return settings ? JSON.parse(settings) : null;
    } catch (error) {
      console.error('Error loading user settings from localStorage:', error);
      return null;
    }
  },
  
  set: (settings: any) => {
    try {
      localStorage.setItem(STORAGE_KEYS.USER_SETTINGS, JSON.stringify(settings));
      return true;
    } catch (error) {
      console.error('Error saving user settings to localStorage:', error);
      return false;
    }
  }
};

/**
 * Pomodoro state storage operations
 */
export const pomodoroStateStorage = {
  get: () => {
    try {
      const state = localStorage.getItem(STORAGE_KEYS.POMODORO_STATE);
      return state ? JSON.parse(state) : null;
    } catch (error) {
      console.error('Error loading pomodoro state from localStorage:', error);
      return null;
    }
  },
  
  set: (state: any) => {
    try {
      const stateWithTimestamp = {
        ...state,
        lastSavedTime: Date.now()
      };
      localStorage.setItem(STORAGE_KEYS.POMODORO_STATE, JSON.stringify(stateWithTimestamp));
      return true;
    } catch (error) {
      console.error('Error saving pomodoro state to localStorage:', error);
      return false;
    }
  }
};

/**
 * User data storage operations
 */
export const userStorage = {
  get: () => {
    try {
      const user = localStorage.getItem(STORAGE_KEYS.USER);
      return user ? JSON.parse(user) : null;
    } catch (error) {
      console.error('Error loading user from localStorage:', error);
      return null;
    }
  },
  
  set: (user: any) => {
    try {
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
      return true;
    } catch (error) {
      console.error('Error saving user to localStorage:', error);
      return false;
    }
  },
  
  remove: () => {
    try {
      localStorage.removeItem(STORAGE_KEYS.USER);
      return true;
    } catch (error) {
      console.error('Error removing user from localStorage:', error);
      return false;
    }
  }
};

/**
 * API token storage operations
 */
export const tokenStorage = {
  get: () => {
    try {
      return localStorage.getItem(STORAGE_KEYS.API_TOKEN);
    } catch (error) {
      console.error('Error loading API token from localStorage:', error);
      return null;
    }
  },
  
  set: (token: string) => {
    try {
      localStorage.setItem(STORAGE_KEYS.API_TOKEN, token);
      return true;
    } catch (error) {
      console.error('Error saving API token to localStorage:', error);
      return false;
    }
  },
  
  remove: () => {
    try {
      localStorage.removeItem(STORAGE_KEYS.API_TOKEN);
      return true;
    } catch (error) {
      console.error('Error removing API token from localStorage:', error);
      return false;
    }
  }
};

// SSR safety check
export const isLocalStorageAvailable = () => {
  if (typeof window === 'undefined') return false;
  
  try {
    const testKey = '__storage_test__';
    localStorage.setItem(testKey, testKey);
    localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
}; 